<template>
  <div class="container">
    <el-card shadow="never" style="margin-bottom: 10px;">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'teachingPointList' }">教学点列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{ mode === 'add' ? '新增教学点' : '编辑教学点' }}</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>

    <el-form ref="teachingPointForm" :model="teachingPointForm" label-width="120px" label-position="right"
             :size="defaultFormItemSize" :rules="rules" @submit.native.prevent
    >
      <el-card shadow="never" style="margin-bottom: 10px;">
        <el-form-item label="教学点名称" prop="pointName">
          <el-input v-model="teachingPointForm.pointName" placeholder="请输入教学点名称" :maxlength="200" show-word-limit />
        </el-form-item>
        <el-form-item label="位置" prop="location">
          <el-input v-model="teachingPointForm.location" placeholder="请输入位置" :maxlength="500" show-word-limit />
        </el-form-item>
        <el-form-item label="经度" prop="longitude">
          <el-input-number v-model="teachingPointForm.longitude" :min="-180" :max="180" :step="0.000001" :precision="6" placeholder="请输入经度" />
        </el-form-item>
        <el-form-item label="纬度" prop="latitude">
          <el-input-number v-model="teachingPointForm.latitude" :min="-90" :max="90" :step="0.000001" :precision="6" placeholder="请输入纬度" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="teachingPointForm.remark" type="textarea" placeholder="请输入备注" :rows="4" :maxlength="500" show-word-limit />
        </el-form-item>
      </el-card>

      <div class="form-button-group">
        <el-button type="primary" :size="defaultFormItemSize" @click="onSaveClick()" :loading="isLoading">{{ mode === 'add' ? '新增' : '保存' }}</el-button>
        <el-button type="default" :size="defaultFormItemSize" @click="onCancelClick()">取消</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { TeachingPointController } from '@/api';
import { mapGetters } from 'vuex';
// eslint-disable-next-line no-unused-vars
import rules from '@/utils/validate.js';

export default {
  name: 'teachingPointForm',
  data () {
    return {
      teachingPointForm: {
        id: undefined,
        pointName: undefined,
        location: undefined,
        longitude: undefined,
        latitude: undefined,
        remark: undefined
      },
      rules: {
        pointName: [
          { required: true, message: '请输入教学点名称', trigger: 'blur' },
          { min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
        ],
        location: [
          { required: true, message: '请输入位置', trigger: 'blur' },
          { min: 1, max: 500, message: '长度在 1 到 500 个字符', trigger: 'blur' }
        ],
        longitude: [
          { required: true, message: '请输入经度', trigger: 'blur' },
          { type: 'number', min: -180, max: 180, message: '经度范围在 -180 到 180 之间', trigger: 'blur' }
        ],
        latitude: [
          { required: true, message: '请输入纬度', trigger: 'blur' },
          { type: 'number', min: -90, max: 90, message: '纬度范围在 -90 到 90 之间', trigger: 'blur' }
        ],
        remark: [
          { max: 500, message: '长度不能超过 500 个字符', trigger: 'blur' }
        ]
      },
      mode: 'add',
      isLoading: false
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  mounted () {
    this.init();
  },
  methods: {
    init () {
      // 获取路由参数
      const query = this.$route.query;
      if (query.mode === 'add') {
        this.mode = 'add';
      } else if (query.id) {
        this.mode = 'edit';
        this.loadTeachingPointDetail(query.id);
      }
    },
    loadTeachingPointDetail (id) {
      this.isLoading = true;
      TeachingPointController.view(this, { id: id }).then(res => {
        this.teachingPointForm = res.data;
      }).catch(e => {
        this.$message.error('加载教学点详情失败');
      }).finally(() => {
        this.isLoading = false;
      });
    },
    onSaveClick () {
      this.$refs.teachingPointForm.validate((valid) => {
        if (valid) {
          this.isLoading = true;
          let params = {
            teachingPointDto: {
              ...(this.mode === 'add' ? {
                pointName: this.teachingPointForm.pointName,
                location: this.teachingPointForm.location,
                longitude: this.teachingPointForm.longitude,
                latitude: this.teachingPointForm.latitude,
                remark: this.teachingPointForm.remark
              } : this.teachingPointForm)
            }
          };

          const savePromise = this.mode === 'add'
            ? TeachingPointController.add(this, params)
            : TeachingPointController.update(this, params);

          savePromise.then(res => {
            this.$message.success(this.mode === 'add' ? '新增成功' : '保存成功');
            this.onCancelClick();
          }).catch(e => {
            this.$message.error(this.mode === 'add' ? '新增失败' : '保存失败');
          }).finally(() => {
            this.isLoading = false;
          });
        } else {
          return false;
        }
      });
    },
    onCancelClick () {
      // 返回教学点列表页面
      this.$router.push({ name: 'teachingPointList' });
    }
  }
}
</script>

<style scoped>
.container {
  padding: 20px;
}

.form-button-group {
  margin-top: 20px;
  text-align: center;
}
</style>
